module.exports = require("dayjs/plugin/objectSupport");